import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 0, label: 'Unspecified' },
    { value: 1, label: 'Teal' },
    { value: 2, label: 'Blue' },
    { value: 3, label: 'Warm' },
    { value: 4, label: 'Monochrome' },
  ],
});
